import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Card,
    AppBar
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Snackbar from '@mui/material/Snackbar';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { addBank, editDeleteBank, } from '../../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

function BankAdd(props) {
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.id : null;
    let navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);

    const [data, setData] = useState({
        id: editid,
        accountName: editData ? editData.accountName : '',
        accountNumber: editData ? editData.accountNumber : '',
        accountType: editData ? editData.accountType : '',
        bankName: editData ? editData.bankName : '',
        branchName: editData ? editData.branchName : '',
        branchCode: editData ? editData.branchCode : '',
        ifscCode: editData ? editData.ifscCode : '',
        swiftCode: editData ? editData.swiftCode : '',
    });

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
    const tzoffset = (new Date()).getTimezoneOffset() * 60000;
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        setOpen(false);
        setOpenSnak(false);

    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.bank.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Bank already available !') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        const bankData = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteBank(bankData));
        } else {
            dispatch(addBank(bankData));
        }
    }

    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Masters', path: '/masters/' },
                        { name: 'Bank List', path: '/masters/bank-masters' },
                        { name: 'Create Bank' },
                    ]}
                />
                <Paper className={`${styles.list_container}`}>

                    <Box sx={{ m: 4 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={2} style={{ minHeight: '350px', paddingLeft: '50px' }}>
                                <Grid item xs={4} >
                                    <Typography > Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} > </Grid>
                                <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <Card className={`${styles.m_card}`}>
                                        <Grid container spacing={1} sx={{ mt: 0 }}>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Account Name</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="accountName"
                                                    value={(data.accountName)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Account Type</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>

                                                <ERPinput
                                                    select
                                                    required
                                                    fullWidth
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="accountType"
                                                    value={(data.accountType)}
                                                    size='small'
                                                    onChange={(e) => handleChange(e)}
                                                >
                                                    <MenuItem value="Current Account" className={`${styles.erp_lable}`}>Current Account</MenuItem>
                                                    <MenuItem value="Over Draft" className={`${styles.erp_lable}`}>Over Draft</MenuItem>
                                                    <MenuItem value="Cash Credit" className={`${styles.erp_lable}`}>Cash Credit</MenuItem>
                                                </ERPinput>
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Branch Name</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="branchName"
                                                    value={(data.branchName)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>IFSC Code</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="ifscCode"
                                                    value={(data.ifscCode)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Account No</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="accountNumber"
                                                    value={(data.accountNumber)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Bank Name</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="bankName"
                                                    value={data.bankName}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Branch Code</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="branchCode"
                                                    value={(data.branchCode)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Swift Code</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    type="text"
                                                    onChange={handleChange}
                                                    name="swiftCode"
                                                    value={(data.swiftCode)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                                <Box sx={{ marginTop: '12px', float: 'right' }}>
                                                    <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                                        <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                                    </Button>
                                                    <Cancel />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}

export default BankAdd